import FeedbackComponent from "./FeedbackComponent.jsx";
import KeyInformation from "./KeyInformation.jsx";
import TotalAttendees from "./TotalAttendees.js";
import UploadFiles from "./UploadFiles.jsx";
import useFormContext from "./useFormContext.js";
import useFormContextFamily from "../GetEventMarsComplete.jsx/useFormMarsComplete.js";

const FamilySummaryRequestor = ({familyMode}) => {
    const { eventFormData } = familyMode==="false" ? useFormContext() : useFormContextFamily();

    const content = (
        <>
            <div className="col-md-10 mb-3">
                {/* feedback */}
                <FeedbackComponent eventId={eventFormData.eventId} />

                {/* files upload and display  */}
                <UploadFiles familyMode={familyMode}></UploadFiles>

                <br/>
            </div>
        </>
    );
    return content;
};
export default FamilySummaryRequestor;